<style lang="scss">
	// levantek-gruas-portada.jpg
  .login-bg {
    background-image: url('../assets/img/levantek-gruas-portada.jpeg');
    background-repeat: no-repeat;
    background-size: cover;
  }
  #login-page{
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100vh;
    & .loginpanel{
      background-color: rgba(255,255,255,.8);
      border-radius: 6px!important;
      margin-left: 0 !important;
    }
  }
</style>
<template>
  <div>
    <div class="row login-bg">
        <div class="col s12">
          <div class="container"><div id="login-page" class="row">
            <div class="col s12 m6 l6 z-depth-4 card-panel border-radius-6 login-card bg-opacity-8 loginpanel">
              <form class="login-form">
                <div class="row">
                  <div class="input-field col s12">
                    <h5 class="ml-4">Sign in</h5>
                  </div>
                </div>
                <div class="row margin">
                  <div class="input-field col s12">
                    <i class="material-icons prefix pt-2">person_outline</i>
                    <input id="username" v-model="login.user" type="text">
                    <label for="username" class="center-align">Username</label>
                  </div>
                </div>
                <div class="row margin">
                  <div class="input-field col s12">
                    <i class="material-icons prefix pt-2">lock_outline</i>
                    <input id="password" v-model="login.pass" type="password">
                    <label for="password" class="">Password</label>
                  </div>
                </div>
                <div class="row">
                  <div class="input-field col s12">
                    <a @click="checkLogin()" class="btn waves-effect waves-light border-round gradient-45deg-purple-deep-orange col s12">Iniciar Sesión</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
          </div>
        <div class="content-overlay"></div>
      </div>
    </div>
  </div>
</template>

<script>
	import firebase from 'firebase/app';
	import firebaseA from '../config';
	import 'firebase/auth';

	import 'materialize-css/dist/css/materialize.min.css';
	import 'material-design-icons/iconfont/material-icons.css';
	// import M from 'materialize-css';
	
	const db  = firebaseA.db;

  
	export default {
		name: "LoginDesktop",
		data() {
			return {
				publicPath: process.env.BASE_URL,
				info: null,
				login:{
					user:"",
					pass:"",
				},
				re:{},
				roldetails:{},
			}
		},
		firestore: {
			roldetails: db.collection('roles'),
		},
		methods: {
			addClassHeader(){
				let $e = document.querySelector("ion-header");
				$e.classList.add("hide-header");

			},
			checkLogin () {
				let $e = this.login.user;
				let $pass = this.login.pass;
				firebase.auth().signInWithEmailAndPassword($e, $pass).then( () => {
				if (firebase.auth().currentUser !== null) 
					this.getUserDetalle(firebase.auth().currentUser.uid);
					// console.log("lalalalalal")
					// this.$router.replace('/solicitudes-admin')
				}).catch((err) => {
					this.showAlert(err.message)
				})
			}, 
			reRedirect() {
				this.$router.replace('/back-office');
			},
			getUserDetalle(_uuid){
				let _self = this;
				db.collection('user_detalles')
				.where('uuid', '==', _uuid)
				.get()
					.then(function(querySnapshot) {
						querySnapshot.forEach(function(doc) {
						// doc.data() is never undefined for query doc snapshots
							// _self.getAcceso(re.rol);
							_self.re     = doc.data();
							_self.re.id  = doc.id;

							_self.$storage.set("user-info",_self.re);
							_self.reRedirect();
						});
					})
					.catch(function(error) {
						console.log("Error getting documents: ", error);
					});
			},
			getAcceso(_rolID) {
				db.collection('roles')
				.doc(_rolID)
				.get()
					.then(function(querySnapshot) {
						querySnapshot.forEach(function(doc) {
						// doc.data() is never undefined for query doc snapshots
						console.log(doc.id, " => ", doc.data());
						});
					})
					.catch(function(error) {
						console.log("Error getting documents: ", error);
					});
			},
			clearInfo() {
				this.info = null;
			},
			showAlert(msg) {
				return this.$ionic.alertController
					.create({
						header: "Error",
						message: msg,
						buttons: ["Aceptar"]
					})
					.then(a => a.present());
			},

		},
		mounted(){

		},
		created() {

		}

	};
</script>
